export const REFERRAL_CONTENT = {
	primaryButton: "Refer now",
	secondaryButton: "Learn more",
	links: {
		primary: "/profile#referrals",
	},
	steps: [
		{
			icon: "/new_icons/general/share-icon.svg",
			title: "Share referral",
			subtitle: "link or code",
		},
		{
			icon: "/new_icons/referral/colleague-icon.svg",
			title: "Colleague joins",
			subtitle: "AutoMint",
		},
		{
			icon: "/new_icons/referral/voucher-icon.svg",
			title: "Get an Amazon",
			subtitle: "Voucher [MAX 5]",
		},
	],
	terms: {
		title: "Referral Program – Terms & Conditions",

		checkboxText: "I accept AutoMint's referral program",
		checkboxLink: "terms and conditions.",
	},
	participateButton: "Participate",
	yourRewards: "YOUR REWARDS",
	referHeading: "REFER YOUR COLLEAGUES, UNLOCK REWARDS",
	claimed: "claimed",
} as const;
